<p [innerHTML]="formattedText"></p>
